import { createReducer, on } from '@ngrx/store'
import { loading } from '../actions/loading.actions'
import { AppStateInterface } from '@shared/interfaces/app.state.interfaces'

export const initialState: AppStateInterface = { loading: true }

export const loadingReducer = createReducer(
    initialState,
    on(loading, ((state, { item }) => {
        return { ...state, loading: item.loading }
    }))
)

